import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const LANGUAGES = [
  { code: 'en', labelKey: 'language.en' },
  { code: 'ru', labelKey: 'language.ru' },
] as const;

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  useEffect(() => {
    const savedLang = localStorage.getItem('i18nextLng');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
      setSelectedLang(savedLang);
    }
  }, [i18n]);

  const handleChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    setSelectedLang(lang);
  };

  return (
    <Select value={selectedLang} onValueChange={handleChange}>
      <SelectTrigger className="w-auto border-none bg-transparent text-white focus:ring-0">
        <SelectValue>
          {t(LANGUAGES.find((l) => l.code === selectedLang)?.labelKey ?? 'language.en')}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map(({ code, labelKey }) => (
          <SelectItem key={code} value={code}>
            {t(labelKey)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
